<template>
  <div class="explore">
    <div class="container">
      <div class="explore__wrapper">
        <img class="explore__image" src="@images/exploreImage.png" alt="image">
        <div class="explore__block">
          <h2 class="explore__title">{{ t('home.explore.title') }}</h2>
          <p class="explore__text">{{ t('home.explore.text') }}</p>
          <button class="explore__button">{{ t('buttons.exploreCollection') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.explore {
  background-image: url(@images/exploreBg.png);
  background-repeat: no-repeat;
  background-size: cover;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-block: 125px 10px;
  }

  &__image {

  }

  &__block {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 25px;
  }

  &__title {
    color: #F3F3F3;
    text-align: right;
    font-size: 64px;
    font-weight: 700;
    text-shadow: 0 0 10px #FF0000;
  }

  &__text {
    width: 675px;
    color: #F3F3F3;
    text-align: right;
    font-size: 20px;
  }

  &__button {
    width: fit-content;
    cursor: pointer;
    border-radius: 10px;
    border: 2px solid #F00;
    background-color: transparent;
    padding: 10px 25px;
    transition: 0.2s;

    color: #F3F3F3;
    text-align: center;
    font-size: 20px;

    @include hover {
      background-color: #FF0000;
    }
  }
}

@media (max-width: 1300px) {
  .explore {
    &__image {
      width: 350px;
    }
  }
}

@media (max-width: 1100px) {
  .explore {
    &__title {
      font-size: 32px;
    }

    &__text {
      width: 100%;
      font-size: 16px;
    }
  }
}

@media (max-width: 900px) {
  .explore {
    &__image {
      width: 250px;
    }
  }
}

@media (max-width: 550px) {
  .explore {
    &__image {
      width: 150px;
    }

    &__title {
      font-size: 26px;
    }

    &__text {
      font-size: 12px;
    }
  }
}
</style>